import request from '@/util/request'

export function updateAlarmSetting(imei,data) {
    return request({
        url: '/device/setting/alarm/'  + imei,
        method: 'put',
        data:data
    })
}
export function getOrder(imei) {
    return request({
        url: '/device/order/' + imei,
        method: 'get'
    })
}
export function updateOrder(imei,data) {
    return request({
        url: '/device/order/' + imei,
        method: 'put',
        data:data
    })
}
export function getBaseInfo(imei) {
    return request({
        url: '/device/baseInfo/' + imei,
        method: 'get'
    })
}
export function deviceList(param) {
    return request({
        url: '/device/list',
        method: 'post',
        data:param
    })
}
export function unBind(imei) {
    return request({
        url: '/device/unBind',
        method: 'post',
        data: {imei}
    })
}

export function updateInfo(data) {
    return request({
        url: '/device/update',
        method: 'post',
        data:data
    })
}
/**
 * 通话
 * @param data
 */
export function phoneCall(data) {
    return request({
        url: '/device/call',
        method: 'post',
        data:data
    })
}

/**
 * 请求通话余额
 * @param {Object} imei 请求数据
 */
export function getCallBalanceInfo(imei) {
    return request({
        url: '/device/call/balance/' + imei,
        method: 'get'
    })
}

/**
 * 获取设备最新MAC信息
 * @param {String} imei 设备IMEI
 * @param {Number} macType MAC类型：1-WIFI，2-蓝牙
 */
export function getLatestMacInfo(imei, macType) {
    return request({
        url: '/device/mac/latest',
        method: 'get',
        params: {
            imei: imei,
            macType: macType
        }
    })
}

/**
 * 获取设备历史MAC信息
 * @param {String} imei 设备IMEI
 * @param {Number} macType MAC类型：1-WIFI，2-蓝牙
 * @param {Number} limit 限制条数
 */
export function getHistoryMacInfo(imei, macType, limit = 100) {
    return request({
        url: '/device/mac/history',
        method: 'get',
        params: {
            imei: imei,
            macType: macType,
            limit: limit
        }
    })
}

export function getActivityHistory(imei, params) {
    return request({url: '/device/activity/history', method: 'get', params: {imei, ...params}})
}
